import { Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

const DefaultIcon = styled('span')(() => ({
  borderRadius: '50%',
  width: 20,
  height: 20,
  border: '2px solid #C2C5CD',
  backgroundColor: 'transparent',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    border: '2px solid #F1F2F6',
  },
  'input:disabled:hover ~ &': {
    backgroundColor: 'transparent',
  },
}));

const CheckedIcon = styled(DefaultIcon)({
  backgroundColor: 'white',
  border: '6px solid #327D5D',
  'input:hover ~ &': {
    backgroundColor: 'white',
  },
  'input:disabled ~ &': {
    border: '6px solid #C2C5CD',
    backgroundColor: '#696D7F',
  },
  'input:disabled:hover ~ &': {
    backgroundColor: '#696D7F',
  },
});

export default function CustomRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      sx={{ padding: 0 }}
      checkedIcon={<CheckedIcon />}
      icon={<DefaultIcon />}
      {...props}
    />
  );
}
